import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';
import { FormValidation } from '../interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurePasswordChecker',
  props: {
  levels: {
    type: Number,
    default: 4,
  },
  validation: {
    type: Object as PropType<FormValidation>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const password = computed(() => {
  return props.validation.$model;
});

const validators = computed(() => {
  const validations = {} as { [key: string]: boolean };
  const passwordValidationsKeys = Object.keys(props.validation).filter((key) => key.includes('password'));
  passwordValidationsKeys.forEach((key) => (validations[key] = props.validation[key].$invalid === false));
  return validations;
});

const validationNumber = computed(() => {
  return Object.keys(validators.value).length;
});

const secureLevelCounter = computed(() => {
  if (!password.value) return 0;
  return Object.values(validators.value).filter((val) => val).length;
});

const hasValidLength = computed(() => {
  return validators.value.passwordLength && password.value;
});

const hasNumber = computed(() => {
  return validators.value.passwordNumber && password.value;
});

const hasSpecialChar = computed(() => {
  return validators.value.passwordSpecialChar && password.value;
});

const hasUpper = computed(() => {
  return validators.value.passwordUpper && password.value;
});

const hasLower = computed(() => {
  return validators.value.passwordLower && password.value;
});

const has = computed(() => {
  return (validation: string) => {
    return Object.keys(validators.value).find((key) => key.includes(validation));
  };
});

return { __sfc: true,props, password, validators, validationNumber, secureLevelCounter, hasValidLength, hasNumber, hasSpecialChar, hasUpper, hasLower, has }
}

})